/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listTeamSchedulesParamsStateDefault = `active`;
export const listTeamSchedulesParamsCursorMax = 512;

export const listTeamSchedulesParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listTeamSchedulesParamsLimitDefault = 50;
export const listTeamSchedulesParamsLimitMax = 100;

export const ListTeamSchedulesParams = zod.object({
  state: zod.enum(['active', 'archived']).default(listTeamSchedulesParamsStateDefault),
  cursor: zod
    .string()
    .min(1)
    .max(listTeamSchedulesParamsCursorMax)
    .regex(listTeamSchedulesParamsCursorRegExp)
    .optional(),
  limit: zod
    .int()
    .min(1)
    .max(listTeamSchedulesParamsLimitMax)
    .default(listTeamSchedulesParamsLimitDefault),
});

export type ListTeamSchedulesParams = zod.input<typeof ListTeamSchedulesParams>;
export type ListTeamSchedulesParamsOutput = zod.output<typeof ListTeamSchedulesParams>;
